<template>
  <div class="main" v-show="qrReady">
    <div class="info-area">
      <p class="title">로그인</p>
      <p class="small-line1">{{ loginMessage }}</p>
      <vue-qrcode class="qr" :value="qrValue" />
      <p class="small-line2">코드 유효시간 {{ remainingTime }} 남음</p>
      <div class="small-line3-spacing">
        <p class="small-line3" v-if="remainingTime === '0:00'">
          *QR 코드가 만료되었습니다
        </p>
      </div>
      <button
        :class="{ focused: focusIndex === 0 }"
        @mouseover="focusIndex = 0"
        @click="enterKeyProc"
        ref="button"
      >
        코드시간 연장
      </button>
      <button
        :class="{ focused: focusIndex === 1 }"
        @mouseover="focusIndex = 1"
        @click="enterKeyProc"
        ref="button"
      >
        나가기
      </button>
      <div class="small-line3-spacing">
        <p class="small-line3" v-if="extensionCount > 1">
          *코드 시간 연장은 1회만 가능합니다
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
import { userInScope } from "@/utils/common";

export default {
  data() {
    return {
      isActiveVue: true,
      remainingTime: "10:00",
      focusIndex: 0,
      extensionCount: 0,
      interval: null,
      timer: null,
      uuid: "",
      qrReady: false,
    };
  },
  components: {
    VueQrcode,
  },
  computed: {
    deviceId() {
      return this.$store.getters.deviceId;
    },
    keyInput() {
      return this.$store.getters.keyInput;
    },
    qrValue() {
      return "key=" + this.uuid + ";deviceId=" + this.deviceId;
    },
    loginMessage() {
      return (process.env.VUE_APP_QR_LOGIN_MESSAGE || "").replace(/\\n/g, "\n");
    },
  },
  watch: {
    keyInput(val, oldVal) {
      if (this.isActiveVue) {
        switch (val.key) {
          case "ArrowLeft":
            this.leftKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },

  methods: {
    leftKeyProc(keyInput) {
      if (this.focusIndex === 1) {
        this.focusIndex = 0;
      }
    },
    rightKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        this.focusIndex = 1;
      }
    },
    enterKeyProc(keyInput) {
      if (this.focusIndex === 0) {
        // 시간연장
        this.extendTime();
      } else {
        // 나가기
        this.moveToLoginView();
      }
    },
    backKeyProc(keyInput) {
      this.moveToLoginView();
    },

    moveToLoginView() {
      this.replaceView("login");
    },

    extendTime() {
      if (this.extensionCount < 1) {
        // 연장하기
        this.$store.dispatch("EXTEND_OTP_TIME", this.uuid).then((response) => {
          if (
            response.data.result == "fail" ||
            response.data.result == "Number of times exceeded"
          ) {
            // 예외처리
          } else {
            ++this.extensionCount;
            this.countDown(10 * 60 * 1000);
          }
        });
      } else {
        ++this.extensionCount;
      }
    },

    login() {
      const self = this;

      const checkReg = () => {
        self.timer = setTimeout(() => {
          clearTimeout(self.timer);
          self.timer = null;

          self.$store
            .dispatch("VERIFY_DEVICE", self.uuid)
            .then((response) => {
              switch (response.data.result) {
                case "expired time":
                  // 시간 만료시 처리
                  break;
                case "fail":
                  // retry
                  checkReg();
                  break;
                default:
                  // 연결 성공
                  // 로그인 요청
                  self.$store
                    .dispatch("REQUEST_LOGIN", {
                      sns: "stv",
                      name: btoa(response.data.result),
                      uuid: self.uuid,
                      deviceId: self.deviceId,
                    })
                    .then((response) => {
                      userInScope(
                        response.data,
                        () => self.replaceView("login-success"),
                        () => self.replaceView("nosubscr")
                      );
                    })
                    .catch((err) => {
                      self.replaceView("login-fail");
                    });
              }
            })
            .catch((error) => {
              checkReg();
            });
        }, 2000);
      };

      this.$progress.$emit("on:progress");

      this.$store
        .dispatch("REGIST_DEVICE", {
          uuid: this.uuid,
          deviceId: this.deviceId,
        })
        .then((response) => {
          this.$progress.$emit("off:progress");

          if (response.data.result == "ok") {
            this.qrReady = true;
            // 장치 등록 체크
            checkReg();
          } else {
            // 로그인 실패 화면으로 이동
            this.replaceView("login-fail");
          }
        })
        .catch((error) => {
          this.qrReady = true;
          this.$progress.$emit("off:progress");

          // 로그인 실패 화면으로 이동
          // this.replaceView('login-fail');

          checkReg();
        });
    },
    countDown(mSec) {
      const self = this;
      clearInterval(self.interval);
      self.remainingTime = self.convertTimeText(mSec);

      self.interval = setInterval(() => {
        if (mSec == 0) {
          clearInterval(self.interval);
        } else {
          mSec = mSec - 1000;
          self.remainingTime = self.convertTimeText(mSec);
        }
      }, 1000);
    },
    convertTimeText(mSec) {
      let min = parseInt(mSec / 60000);
      let sec = parseInt(mSec % 60000) / 1000;
      if (sec < 10) {
        sec = "0" + sec;
      }
      return min + ":" + sec;
    },
    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
      clearInterval(this.interval);
      this.interval = null;
    },
    replaceView(targetName) {
      this.clearTimer();
      this.$router.replace({
        name: targetName,
        params: {
          t: new Date().getTime(),
        },
      });
    },
    createUuid() {
      const uuid = this.$uuid.v4();
      this.uuid = btoa(uuid);
      this.$store.commit("SET_UUID", uuid);
    },
  },

  created() {
    const self = this;
    this.createUuid();
    this.$store.dispatch("FETCH_DEVICE_ID", function() {
      self.login();
    });
  },

  mounted() {
    this.countDown(10 * 60 * 1000);
  },

  beforeDestroy() {
    this.clearTimer();
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  left: 0;
  top: 0;
  width: 1920px;
  height: 1080px;
}
.info-area {
  position: absolute;
  left: 96px;
  top: 198px;
}
.title {
  font-size: 56px;
  line-height: 1;
  color: #eeeeee;
  margin-bottom: 40px;
}
.small-line1 {
  font-size: 28px;
  line-height: 1.29;
  color: #888888;
  margin-bottom: 40px;
  white-space: pre-wrap;
}
.qr {
  width: 240px;
  height: 240px;
  margin-bottom: 24px;
}
.small-line2 {
  font-size: 28px;
  line-height: 1;
  color: #eeeeee;
  margin-bottom: 12px;
}
.small-line3 {
  font-size: 24px;
  line-height: 1;
  color: #ff0050;
}
.small-line3-spacing {
  height: 24px;
}
button {
  width: 272px;
  height: 80px;
  background-color: #3e3e3e;
  font-size: 28px;
  color: #eeeeee;
  margin-top: 72px;
  margin-bottom: 17px;
  margin-right: 24px;
  border: none;
}
button.focused {
  border: solid 4px #eeeeee;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .main {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
  }
  .info-area {
    position: absolute;
    left: 80px;
    top: 86px;
  }
  .title {
    font-size: 56px;
    line-height: 1;
    color: #ffffff;
    margin-bottom: 16px;
  }
  .small-line1 {
    font-size: 20px;
    line-height: 1.5;
    margin-bottom: 48px;
  }
  .qr {
    width: 160px;
    height: 160px;
    margin-bottom: 24px;
  }
  .small-line2 {
    font-size: 20px;
    line-height: 1;
    color: #ffffff;
    margin-bottom: 12px;
    font-weight: bold;
  }
  .small-line3 {
    font-size: 24px;
    line-height: 1;
    color: #ff0050;
  }
  .small-line3-spacing {
    height: 24px;
  }
  button {
    width: 160px;
    height: 56px;
    background-color: #3e3e3e;
    font-size: 18px;
    color: #eeeeee;
    margin-top: 85px;
    margin-right: 16px;
    margin-bottom: 0px;
    border: none;
  }
  button.focused {
    border: solid 3px #eeeeee;
  }
}
</style>
